import Cookies from 'universal-cookie';
import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker";
CheckWebpFeature();
export { wrapRootElement } from "./src/common/apollo/wrap-root-element";

const cookies = new Cookies();

// ---------------------------------------------------------------------------
// Iovox DNI integration
// ---------------------------------------------------------------------------
// Load iovox after React has hydrated so phone-number replacements are not
// reverted on a fresh page load.
let __iovoxReady = false;
let __iovoxPendingReplace = false;

function runIovoxAutoReplace() {
  if (typeof window === "undefined") return;
  if (!__iovoxReady || !window.iovox) {
    __iovoxPendingReplace = true;
    return;
  }
  try {
    var medium = window.iovox.detectMedium();
    var sourceMap = {
      ppc: "paid_search",
      cpc: "paid_search",
      organic: "organic_search",
      social: "organic_social",
    };
    var source = sourceMap[medium] || medium;
    if (window.iovox.detectCampaign() === "gmb") source = "gmb";
    window.iovox.autoReplace({ source: source }, { source: "website" });
  } catch (e) {
    console.error("iovox autoReplace error:", e);
  }
}

function scheduleIovoxAutoReplace() {
  runIovoxAutoReplace();
  setTimeout(runIovoxAutoReplace, 300);
  setTimeout(runIovoxAutoReplace, 800);
  setTimeout(runIovoxAutoReplace, 1500);
}

function loadIovoxScript() {
  if (typeof window === "undefined") return;
  if (window.__iovoxScriptInjected) {
    scheduleIovoxAutoReplace();
    return;
  }

  var accessKey = process.env.GATSBY_IOVOX_ACCESS_KEY;
  var actionKey = process.env.GATSBY_IOVOX_ACTION_KEY;
  if (!accessKey || !actionKey) return;

  window.__iovoxScriptInjected = true;

  var s = document.createElement("script");
  s.src = "https://cdn.iovox.com/rest/v2/dni.js";
  s.async = true;
  s.onload = function () {
    try {
      window.iovox.init({
        access_key: accessKey,
        action_key: actionKey,
      });
      __iovoxReady = true;
      scheduleIovoxAutoReplace();
      if (__iovoxPendingReplace) {
        __iovoxPendingReplace = false;
        setTimeout(scheduleIovoxAutoReplace, 800);
      }
    } catch (e) {
      console.error("iovox init error:", e);
    }
  };
  s.onerror = function () {
    window.__iovoxScriptInjected = false;
    console.error("Failed to load iovox dni.js");
  };
  document.head.appendChild(s);
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}, themeOptions) => {

  //     // Avoid to scroll to top when next page trigger click
  //     // But this feature should condiser with details page back scroll too

  //       //console.log("getSavedScrollPosition", getSavedScrollPosition, themeOptions);
  //       const { pathname } = location
  //       const scrollToTopRoutes = [`/property/for-sale/`, `/property/to-rent/`, `/${themeOptions.news_insight}/`]

  //       if (scrollToTopRoutes.indexOf(pathname) !== -1) {
  //         window.scrollTo(0, 0)
  //       }

  const currentPosition = getSavedScrollPosition(location)
  //const queriedPosition = getSavedScrollPosition({ pathname: `/page-2/` })

  //console.log("currentPosition result: 1",currentPosition)
  //console.log("queriedPosition result:", queriedPosition)

  if (currentPosition?.length > 0 && currentPosition[1] > 0) {

    //console.log("currentPosition result: 2", currentPosition)

    setTimeout(() => {
      if (currentPosition[1] > 0) {
        window.scrollTo(0, currentPosition[1])
      }
    }, 200)


    if (location.pathname.match(/property\/for-sale/)) {
      return false;
    }
    if (location.pathname.match(/property\/to-rent/)) {
      return false;
    }

    if (location.pathname.match(/commercial-property\/for-sale/)) {
      return false;
    }
    if (location.pathname.match(/commercial-property\/to-rent/)) {
      return false;
    }

    if (location.pathname.match(/property-students\/to-rent/)) {
      return false;
    }

  }




  return true;
};

// export function shouldUpdateScroll(prevRouterProps, { location }) {
//     //console("location =>", prevRouterProps, location)
//     window.scrollTo(0, 0)
//     const body = document.getElementsByTagName('body')[0]
//     body.scrollTop = 0
//     return false
// }

export const onRouteUpdate = ({ location, prevLocation }) => {
  // if (location.pathname.split('?').length > 0) {
  //   window.history.replaceState(null, '', location.pathname);
  // } 

  const params = new URLSearchParams(location.search);

  // Track UTM Parameters
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_gclid", "gclid"];
  let utmData = {};
  if (typeof sessionStorage !== "undefined") {
    try {
      utmData = JSON.parse(sessionStorage.getItem("utm_data") || "{}");
    } catch (e) { }
  }

  let hasUtm = false;
  utmKeys.forEach(key => {
    if (params.has(key)) {
      // Map gclid to utm_gclid as requested
      const storeKey = key === "gclid" ? "utm_gclid" : key;
      utmData[storeKey] = params.get(key);
      // params.delete(key);
      hasUtm = true;
    }
  });

  if (hasUtm) {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("utm_data", JSON.stringify(utmData));
    }
    // const newSearch = params.toString();
    // const newUrl = location.pathname + (newSearch ? '?' + newSearch : '') + location.hash;
    // window.history.replaceState({}, '', newUrl);
  }

  var parameter1 = params.get("transType");

  //console.log("pathname", location)

  const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
  const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g, '-');


  if (location.pathname === "/property-for-sale/") {
    window.location.replace("/property/for-sale/in-" + defaultArea_Slug);
  }

  if (location.pathname === "/property-to-rent/") {
    window.location.replace("/property/to-rent/in-" + defaultArea_Slug);
  }

  // Redirect for michealjones
  if (location.pathname.indexOf("property-for-sale") > 0 && location.search.indexOf("transType=1") > 0) {
    window.location.replace("/property/for-sale/in-" + defaultArea_Slug);
  }

  // Redirect for matthewsofchester
  if (location.search.indexOf("corpsector") > 0 || location.search.indexOf("testimonials") > 0) {
    window.location.replace("/");
  }

  // Redirect for miles and barr
  if (location.pathname.indexOf("property") > 0 && location.search.indexOf("propertyID") > 0) {
    window.location.replace("/property/for-sale/in-" + defaultArea_Slug);
  }

  //console.log("old pathname", prevLocation?.search?.indexOf("utm_source"))

  if (typeof window !== "undefined") {
    loadIovoxScript();
    setTimeout(scheduleIovoxAutoReplace, 500);
  }

}

// const addScript = url => {
//   const script = document.createElement("script")
//   script.src = url
//   script.async = true
//   script.defer = true
//   document.body.appendChild(script)
// }

function initChatOnEvent(event) {
  initChat();
  //event.currentTarget.removeEventListener(event.type, initChatOnEvent);
}
// Initializes Google Tag Manager
function initChat() {
  if (window.chatDidInit) {
    // Don't load again
    return false;
  }
  window.chatDidInit = true;
  try {
    (function () {
      // var theScript = document.createElement("script");
      // theScript.setAttribute("type", "text/javascript");
      // theScript.setAttribute("defer", "true");
      // theScript.setAttribute("src", "https://bot.leadoo.com/bot/dynamic.js?company="+process.env.GATSBY_LEADOO_CHAT_ID+"&mode=spa");
      // document.getElementsByTagName("head")[0].appendChild(theScript);

      // if(process.env.GATSBY_LEADOO_CHAT_ID){
      //   LeadooChatBot();
      // }

      // if(process.env.GATSBY_ONETRUST_ID){

      //   let get_ot_cookie = cookies?.get('OptanonConsent')
      //   let split_cookie = get_ot_cookie?.split("&");

      //   if(split_cookie?.length > 0 && split_cookie?.includes('AwaitingReconsent=false')){

      //   } else{
      //     OneTrust();
      //   }
      // }

    })();
  } catch (error) {
    console.log("error", error);
  }
}

// function LeadooChatBot() {
//   var theScript = document.createElement("script");
//   theScript.setAttribute("type", "text/javascript");
//   theScript.setAttribute("defer", "true");
//   theScript.setAttribute("src", "https://bot.leadoo.com/bot/dynamic.js?company="+process.env.GATSBY_LEADOO_CHAT_ID+"&mode=spa");
//   document.getElementsByTagName("head")[0].appendChild(theScript);
// }

// function OneTrust() {
//   var theScript = document.createElement("script");
//   theScript.setAttribute("type", "text/javascript");
//   theScript.setAttribute("defer", "true");
//   theScript.setAttribute("src", `https://cdn-ukwest.onetrust.com/consent/${process.env.GATSBY_ONETRUST_ID}/OtAutoBlock.js`);
//   document.getElementsByTagName("head")[0].appendChild(theScript);

//   var theScript2 = document.createElement("script");
//   theScript2.setAttribute("type", "text/javascript");
//   theScript2.setAttribute("defer", "true");
//   theScript2.setAttribute("charset", "UTF-8");
//   theScript2.setAttribute("data-domain-script", process.env.GATSBY_ONETRUST_ID);
//   theScript2.setAttribute("src", "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js");
//   document.getElementsByTagName("head")[0].appendChild(theScript2);
// }

export const onClientEntry = () => {

  //const renderComponent = RenderComponent()

  // Load the script after the user scrolls, moves the mouse, or touches the screen
  if (process.env.GATSBY_LEADOO_CHAT_ID || process.env.GATSBY_ONETRUST_ID) {
    document.addEventListener('scroll', initChatOnEvent);
    document.addEventListener('mousemove', initChatOnEvent);
    document.addEventListener('touchstart', initChatOnEvent);

    //initChatOnEvent();
  }

  window.onload = () => {
    sessionStorage.removeItem("pageView")

    // if(process.env.GATSBY_LEADOO_CHAT_ID){
    //   addScript("https://bot.leadoo.com/bot/dynamic.js?company="+process.env.GATSBY_LEADOO_CHAT_ID+"&mode=spa")
    // }
  }
}

export const onInitialClientRender = () => {
  loadIovoxScript();

  const GTM_ID = process.env.GATSBY_GTM_ID
  const GTM_ID_2 = process.env.GATSBY_GTM_ID1

  if (!GTM_ID && !GTM_ID_2) return

  // Use requestIdleCallback for better performance
  // const loadGTM = () => {
  //   if (window.gtmDidLoad) return
  //   window.gtmDidLoad = true

  //   window.dataLayer = window.dataLayer || []
  //   window.dataLayer.push({ event: "gtm.js", platform: "gatsby" })

  //   if(GTM_ID){
  //     const script = document.createElement("script")
  //     script.async = true
  //     script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  //     document.head.appendChild(script)
  //   }
  //   if(GTM_ID_2){
  //     const script_2 = document.createElement("script")
  //     script_2.async = true
  //     script_2.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID_2}`
  //     document.head.appendChild(script_2)
  //   }

  // }

  // Load GTM lazily: after the page becomes idle
  // if ("requestIdleCallback" in window) {
  //   requestIdleCallback(loadGTM)
  // } else {
  //   window.addEventListener("load", loadGTM)
  // }
}



